export default "__VITE_ASSET__rdbiiVk9__"